import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { defaultEnd, defaultStart } from './utils/date';

export const useQueryParams = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const useStartAndEnd = () => {
  const queryParams = useQueryParams();

  return React.useMemo(() => {
    let start = defaultStart();
    if (queryParams.get('start')) {
      start = new Date(queryParams.get('start'));
    }

    let end = defaultEnd();
    if (queryParams.get('start')) {
      start = new Date(queryParams.get('start'));
    }

    const interval = queryParams.get('interval') ?? 'day';

    return {
      start,
      end,
      interval,
    };
  }, [queryParams]);
};

export const useInputChangeHandler = (handler: (value: string) => void): React.ChangeEventHandler<HTMLInputElement> => {
  const onChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(
    (e) => {
      handler(e.target.value);
    },
    [handler]
  );

  return onChange;
};

export const useInputState = (initialValue: string): [string, React.ChangeEventHandler<HTMLInputElement>] => {
  const [value, setValue] = React.useState(initialValue);
  const onChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(
    (e) => {
      setValue(e.target.value);
    },
    [setValue]
  );

  return [value, onChange];
};
